module.exports = ":host {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-align-items: center;\n      -ms-flex-align: center;\n          align-items: center;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/checklist/checklist.component.scss
// module id = 1215
// module chunks = 0